module.exports = __webpack_public_path__ + "img/Finance.a1a44a47.png";